<template>
    <div class="list-info">
        <ul >
            <li  class="info ancient" v-for="(item,num) in studyListInfo" :key="num" @click="toPage(item,'book')">
                <a>
                    <div class="info-pic">
                        <img height="100%" :src="item.coverPath" alt="">
                    </div>
                    <div class="info-txt"> 
                        <div class="txt-tit">{{item.bookName}}</div>
                        <div class="txt">作者：{{item.author}}</div>
                        <div class="txt">分类：{{item.classification}}</div>
                        <div class="txt">朝代：{{item.dynasty}}</div>
                        <div class="txt txt-info">介绍：{{item.introduction}}</div>
                    </div>
                </a>
            </li>
        </ul>
        <div v-if="studyListInfo&&studyListInfo.length>=6" class="look-more" @click="toPage(studyListInfo,'more')">查看更多</div>
    </div>
</template>

<script>

import { indexBookList } from '../../../../io/api';
export default {
    components: {},
    data() {
        return {
            studyListInfo:[],
        }
    },
    watch: {},
    mounted() {
        this.getList();
    },
    methods: {
        getList(){ 
            indexBookList().then(res => {
                let {code,data,msg}=res.data;
                if(code==0){
                    this.studyListInfo=data.list||[]; 
                   
                }else{
                    this.$message.error(msg||'请求失败～');
                }
            })

        },

        toPage(item, type) {
            // 查看更多：进入学古籍页好书推荐
            if (type === 'more') {
                const url = this.$router.resolve({
                    path: '/studyPage',
                });
                this.$windowOpen({ url: url.href, isLogin: true });
                return;
            }
            // 单本书：进入目录页
            const url = this.$router.resolve({
                path: '/bookCatalogue',
                query: {
                    id: item.id,
                },
            });
            this.$windowOpen({ url: url.href, isLogin: true });
        },
        
    }
}
</script>
<style lang='less' scoped>
    @import url('./study.less');
    .list-info{
        .look-more{
            margin-top: 14px;
        }
    }
    
</style>